/**
 * APP.JS - Eliminate Tobacco Use
 */

// jQuery (ES module import, assign to window before any plugins load)
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// Import styles
import '../css/app.scss';

// Import Bootstrap
import * as bootstrap from 'bootstrap';

// Import jQuery plugins using top-level await (requires jQuery on window first)
await Promise.all([
  import('./plugins/fitvids/fitvids.js'),
  import('./plugins/velocity/velocity.js'),
  import('jquery.cycle2')
]);

// App initialization
$(function() {
  // Responsive video embeds
  $(".js-fitvids").fitVids();

  // Initialize Cycle2 toolkit panels (if present on page)
  const $toolkitPanels = $("#toolkit-panels");
  if ($toolkitPanels.length) {
    $toolkitPanels.cycle({
      fx: "scrollHorz",
      paused: true,
      slides: "> div",
      pager: "#toolkit-buttons",
      pagerTemplate: "",
      autoHeight: "container"
    }).on('cycle-after', function(e, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
      // cycle complete callback
    });

    // Resize Cycle2 container when accordion panels are shown/hidden
    $('.accordion-collapse').on('shown.bs.collapse hidden.bs.collapse', function() {
      $(window).trigger('resize');
    });
  }

  // Scroll to anchor when landing on page with hash in url
  if (window.location.hash) {
    $('a[href^="' + window.location.hash + '"]').first().trigger('click');
  }

  // Scroll to same page anchors
  $('a[href^="#"]').not('[data-bs-toggle]').click(function(e) {
    var hash = $(this).attr('href').match(/#([^ ]*)/)[1];

    $('#' + hash).velocity("scroll", {
      duration: 500,
      easing: "easeInOutQuant",
      offset: -100,
      mobileHA: false
    });
  });
});
